import { addToCartInitialState } from '@/domains/shoppingCart/AddToCart/AddToCart.interfaces';

import {
  A2C_CONFIG_PROCESSING_FAILED,
  A2C_CONFIG_PROCESSING_SUCCESS,
  A2C_FETCH_PRODUCTS_RECOMMENDATION,
  A2C_FETCH_PRODUCTS_RECOMMENDATION_FAILED,
  A2C_FETCH_PRODUCTS_RECOMMENDATION_SUCCESS,
  A2C_FETCH_RECOMMENDATION_CONFIG,
  A2C_FETCH_RECOMMENDATION_CONFIG_FAILED,
  A2C_FETCH_RECOMMENDATION_CONFIG_SUCCESS,
  ADD_TO_CART_FAILED,
  ADD_TO_CART_REQUEST,
  ADD_TO_CART_SUCCESS,
  HIDE_ADD_T0_CART_MODAL,
  HIDE_CROSS_PLATFORM_PURCHASE_BLOCKED_MODAL,
  SHOW_ADD_T0_CART_MODAL,
  SHOW_CROSS_PLATFORM_PURCHASE_BLOCKED_MODAL,
  type AddToCartReducerAction,
} from './AddToCart.actions';

export const addToCartReducer = (
  state = addToCartInitialState,
  action: AddToCartReducerAction,
) => {
  switch (action.type) {
    case ADD_TO_CART_REQUEST:
      return {
        ...state,
        isPending: true,
        products: state.products.length
          ? state.products
          : action.payload.products,
        offer: action.payload.offer,
        playlistReconciliation: action.payload.playlistReconciliation,
        displayAddToCartCustomSummary:
          action.payload.displayAddToCartCustomSummary,
      };

    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        savedProductIds: state.savedProductIds.concat(
          action.payload.savedProductIds,
        ),
        playlistReconciliation: action.payload.playlistReconciliation,
        products: action.payload.products,
        productsTotalPrice: action.payload.productsTotalPrice,
        isPending: false,
      };

    case ADD_TO_CART_FAILED:
      return {
        ...state,
        errors: state.errors.concat(action.errors),
        isPending: false,
        savedProductIds: action?.payload?.savedProductIds
          ? state.savedProductIds.concat(action?.payload?.savedProductIds)
          : state.savedProductIds,
      };

    case SHOW_ADD_T0_CART_MODAL:
      return {
        ...state,
        isVisible: action.payload.showConfirmationMessage ?? true,
      };

    case HIDE_ADD_T0_CART_MODAL:
      state = addToCartInitialState; // eslint-disable-line no-param-reassign
      return state;

    case SHOW_CROSS_PLATFORM_PURCHASE_BLOCKED_MODAL:
      return {
        ...addToCartInitialState,
        showCrossBorderPurchaseBlockedModal: true,
      };

    case HIDE_CROSS_PLATFORM_PURCHASE_BLOCKED_MODAL:
      return {
        ...state,
        showCrossBorderPurchaseBlockedModal: false,
      };

    case A2C_FETCH_RECOMMENDATION_CONFIG:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          fetching: true,
        },
      };

    case A2C_FETCH_RECOMMENDATION_CONFIG_SUCCESS:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          recommendationsConfig: action.config,
          fetching: false,
        },
      };

    case A2C_FETCH_RECOMMENDATION_CONFIG_FAILED:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          fetching: false,
          error: action.error.message,
          recommendationsConfig: [],
        },
      };

    case A2C_FETCH_PRODUCTS_RECOMMENDATION:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          fetching: true,
        },
      };

    case A2C_FETCH_PRODUCTS_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          fetching: false,
          recommendations: action.recommendations,
        },
      };

    case A2C_FETCH_PRODUCTS_RECOMMENDATION_FAILED:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          fetching: false,
          error: action.error.message,
          recommendations: [],
        },
      };

    case A2C_CONFIG_PROCESSING_SUCCESS:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          recommendationsConfig: action.config,
          fetching: false,
        },
      };

    case A2C_CONFIG_PROCESSING_FAILED:
      return {
        ...state,
        productRecommendation: {
          ...state.productRecommendation,
          fetching: false,
          error: action.error.message,
          recommendationsConfig: [],
        },
      };

    default:
      return state;
  }
};
